/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { Button, Modal } from '@mairistem/composants';

import type { Individu } from '@/types';
import RecenseListeContainer from '@/components/Recense/Liste/RecenseListeContainer';
import dayjs from 'dayjs';
import { request } from '@mairistem/tools';
import { toast } from 'react-toastify';

interface RattachementIndividuHubeeModalProps {
  open: boolean;
  onClose: () => void;
  demandeur?: {
    prenom?: string;
    nom?: string;
    jourNaissance?: number;
    moisNaissance?: number;
    anneeNaissance?: number;
  };
  identifiantTeledossier?: string;
}

const RattachementIndividuHubeeModal = (
  props: RattachementIndividuHubeeModalProps,
) => {
  const { open, onClose, demandeur, identifiantTeledossier } = props;

  const [selectedItem, setSelectedItem] = React.useState<Partial<Individu>>();

  const [rattacher, setRattacher] = React.useState(true);

  const defaultDateNaissance = React.useMemo(() => {
    if (!demandeur) return null;
    const { anneeNaissance, moisNaissance, jourNaissance } = demandeur;
    return dayjs(
      `${anneeNaissance}-${String(moisNaissance).padStart(2, '0')}-${String(jourNaissance).padStart(2, '0')}`,
    ).toDate();
  }, [demandeur]);

  const handleSelect = React.useCallback((item: Partial<Individu>) => {
    setSelectedItem(item);
  }, []);

  const handleValidate = React.useCallback(() => {
    if (!selectedItem?.identifiant) return;

    request
      .patch(
        `/api/administres/recensement-citoyen/individus/${selectedItem.identifiant}`,
        { identifiantTeledossier },
      )
      .then(() => {
        toast('Recensé rattaché avec succès', { type: 'success' });
        onClose();
      })
      .catch(() => {
        toast('Erreur lors du rattachement', { type: 'error' });
      });
  }, [selectedItem, identifiantTeledossier, onClose]);

  const handleClose = React.useCallback(() => {
    setSelectedItem(undefined);
    setRattacher(true);
    onClose();
  }, [onClose]);

  return (
    <Modal closeIcon open={open} onClose={handleClose} size="large">
      <Modal.Header>Rattachement du télédossier à un individu</Modal.Header>
      <Modal.Content style={{ overflow: 'hidden' }}>
        <div
          style={{
            height: '700px',
          }}
        >
          <RecenseListeContainer
            simplified
            onSelect={rattacher ? handleSelect : undefined}
            defaultSearch={`${demandeur?.nom} ${demandeur?.prenom}`}
            defaultDateNaissance={defaultDateNaissance}
          />
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          basic
          size="small"
          icon="close"
          content="Ne pas rattacher d'individu"
          onClick={handleClose}
        />
        <Button
          positive
          size="small"
          icon="checkmark"
          content="Valider"
          disabled={!rattacher || _.isNil(selectedItem)}
          onClick={handleValidate}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default RattachementIndividuHubeeModal;
